module.exports = __webpack_public_path__ + "media/images/pdf-9b827ac62cdf2fb23901b1ef4bc3069a.png";